import { BCMSRecord, Workflow, useGlobalController, useParams } from "@bcm-dev/bcms-vite";
import ParticipantDetailsPage from "components/pages/ParticipantDetailsPage";
import Classes from "model";
import React from "react";

// Steps of the workflow
const steps = [ ParticipantDetailsPage ];

/**
 * @function AddACHParticipantWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for adding an ach participant
 */
export default function AddACHParticipantWorkflow(props) {
    const controller = useGlobalController();
    const { stepID } = useParams();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />;
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);
    // Return the default workflow state
    return { 
        data: {
            defaultParticipant:  {
                participantType: "standard",
                participantName: "Thomas Jefferson",
                participantEmail: "tjefferson@presidentsinc.com",
                nickname: "TJefferson",
                institutionName: "PRESIDENTS BANK AND TRUST",
                uniqueID: "555-66-7777",
                createdDate: 0,
                group: "Employee",
                number: "1234567",
                confirmedAccountNumber: "1234567",
                routing: "99988766",
                accountType: "Checking",
                status: "Active",
                discretionaryData: "",
                distributePayments: "false",
                isChecked: "false"
            }
        }
    };
};